<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Media Partners
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/neweco.png'), class: 'full-logo', name: 'New Economy', url: 'https://x.com/neweconomy_g?utm_source=chatgpt.com' },
      { logo: require('@/assets/logos/pacificmeta.png'), class: 'full-logo', name: 'Pacific Meta', url: 'https://x.com/PacificMeta' },
      { logo: require('@/assets/logos/iolite.png'), class: 'full-logo', name: 'Iolite', url: 'https://x.com/Iolite_japan' },
      { logo: require('@/assets/logos/Cointelegraph.png'), class: 'full-logo', name: 'Cointelegraph Japan', url: 'https://x.com/JpCointelegraph' },
      { logo: require('@/assets/logos/cryptotimes.png'), class: 'full-logo', name: 'Crypto Times', url: 'https://x.com/CryptoTimes_mag' },
      { logo: require('@/assets/logos/panews.png'), class: 'full-logo', name: 'PANews', url: 'https://x.com/PANewsCN' },
      { logo: require('@/assets/logos/akindo.png'), class: 'full-logo', name: 'AKINDO', url: 'https://x.com/akindo_io' },
      { logo: require('@/assets/logos/fracton.png'), class: 'full-logo', name: 'Fracton venture', url: 'https://x.com/wecandaoit' },
      { logo: require('@/assets/logos/slash.svg'), class: 'full-logo', name: 'Slash Vision Labs', url: 'https://x.com/SlashWeb3' },
    ]);
    return {
      partners
    };
  },
};
</script>
